module.exports = __webpack_public_path__ + "img/20210713134147459mfs.de29ff77.png";